<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
        </div>
        <el-table :data="dataTree" style="width: 100%;" row-key="permissionId" border default-expand-all
            :tree-props="{ children: 'children' }">
            <el-table-column prop="permissionName" label="权限名称"></el-table-column>
            <el-table-column prop="permissionUrl" label="权限地址"></el-table-column>
            <el-table-column prop="permissionIcon" label="权限图标"></el-table-column>
            <el-table-column prop="permissionSort" label="权限序号"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    {{ scope.row.permissionStatus == 1 ? "启用" : "禁用" }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.permissionDate) }}
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="80px">
                    <el-form-item label="权限名称">
                        <el-input v-model="handleInfo.permissionName"></el-input>
                    </el-form-item>
                    <el-form-item label="权限URL">
                        <el-input v-model="handleInfo.permissionUrl"></el-input>
                    </el-form-item>
                    <el-form-item label="权限状态">
                        <el-select v-model="handleInfo.permissionStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="权限图标">
                        <el-input v-model="handleInfo.permissionIcon"></el-input>
                    </el-form-item>
                    <el-form-item label="权限序号">
                        <el-input v-model="handleInfo.permissionSort"></el-input>
                    </el-form-item>
                    <el-form-item label="父级权限">
                        <el-select v-model="handleInfo.permissionParent" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in parentList" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            parentList: [{
                name: "无",
                value: "0"
            }],
            dataTree: [],
            treeProps: {
                label: "permissionName",
                value: "permissionId",
                children: "children"
            }
        }
    },
    methods: {
        getData: async function () {
            this.parentList = [{
                name: "无",
                value: "0"
            }];
            let arr = await doGet(API.ALL.PERMISSION);
            if (arr != null) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].permissionParent == "0") {
                        this.parentList.push({
                            name: arr[i].permissionName,
                            value: arr[i].permissionId
                        });
                    }
                }
            }
            this.dataTree = await doGet(API.TREE.PERMISSION);
        },
    },
    created: function () {
        this.tag = "PERMISSION";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>